import { Decimal } from 'decimal.js';

// fix 0.3 - 0.1 = 0.19999999999999998
export function safeSub(x: number, y: number) {
	return Decimal.sub(x, y).toNumber();
}
